import type { common as en } from "../en/common";
import type { Messages } from "../types";

export const common: Messages<typeof en> = {
  product: "ملفك",
  tagline: "سوشال ميديا، بلا عناء.",
  actions: {
    save: "حفظ",
    saveChanges: "حفظ التغييرات",
    cancel: "إلغاء",
    close: "إغلاق",
    confirm: "تأكيد",
    delete: "حذف",
    edit: "تعديل",
    create: "إنشاء",
    add: "إضافة",
    remove: "إزالة",
    retry: "أعد المحاولة",
    reload: "إعادة التحميل",
    back: "رجوع",
    next: "التالي",
    skip: "تخطٍّ",
    done: "تم",
    continue: "متابعة",
    apply: "تطبيق",
    reset: "إعادة ضبط",
    clear: "مسح",
    copy: "نسخ",
    copied: "تم النسخ",
    search: "بحث",
    filter: "تصفية",
    export: "تصدير",
    exportCsv: "تصدير CSV",
    viewAll: "عرض الكل",
    more: "المزيد",
    open: "فتح",
    approve: "موافقة",
    reject: "رفض",
    send: "إرسال",
    reply: "رد",
    hide: "إخفاء",
    unhide: "إظهار",
    assign: "إسناد",
    markDone: "تم",
    reopen: "إعادة فتح",
    regenerate: "توليد من جديد",
    insert: "إدراج",
    generate: "توليد",
    upload: "رفع",
    connect: "ربط",
    disconnect: "فصل",
    schedule: "جدولة",
    publishNow: "انشر الآن",
    learnMore: "اعرف المزيد",
    selectAll: "تحديد الكل",
    deselect: "إلغاء التحديد",
    undo: "تراجع",
  },
  states: {
    loading: "جارٍ التحميل…",
    saving: "جارٍ الحفظ…",
    saved: "تم الحفظ",
    error: "حدث خطأ ما",
    errorHint: "تعذّر التحميل. تحقّق من الاتصال ثم أعد المحاولة.",
    empty: "لا يوجد شيء هنا بعد",
    offline: "أنت غير متصل. ستُزامَن التغييرات عند عودة الاتصال.",
    backOnline: "عاد الاتصال",
    notFound: "غير موجود",
    comingSoon: "قريباً",
    beta: "تجريبي",
    new: "جديد",
    on: "مفعّل",
    off: "متوقف",
    all: "الكل",
    none: "لا شيء",
    unknown: "غير معروف",
    you: "أنت",
    requestId: "معرّف الطلب",
  },
  noOrg: {
    title: "لست عضواً في أي مؤسسة بعد",
    hint: "أنشئ مؤسستك للمتابعة، وستكون مالكها.",
    create: "إنشاء مؤسسة",
  },
  errors: {
    network: "تعذّر الوصول إلى منصة ملفك. تحقّق من اتصالك.",
    unauthorized: "انتهت جلستك. سجّل الدخول من جديد.",
    forbidden: "ليست لديك صلاحية لهذا الإجراء.",
    notFound: "هذا العنصر لم يعد موجوداً.",
    rateLimited: "طلبات كثيرة. انتظر قليلاً ثم أعد المحاولة.",
    validation: "بعض الحقول تحتاج إلى مراجعة.",
    server: "واجه الخادم مشكلة، وتم إبلاغنا.",
    boundaryTitle: "واجهت هذه الشاشة مشكلة",
    boundaryHint: "باقي ملفك يعمل. أعد المحاولة أو ارجع للرئيسية.",
    notFoundTitle: "هذه الصفحة غير موجودة",
    notFoundHint: "ربما الرابط غير صحيح، أو نُقلت الصفحة.",
    goHome: "الرئيسية",
  },
  channels: {
    instagram: "إنستغرام",
    facebook_page: "صفحة فيسبوك",
    messenger: "ماسنجر",
    whatsapp: "واتساب",
    threads: "ثريدز",
    tiktok: "تيك توك",
  },
  accountStatus: {
    active: "نشط",
    needs_reauth: "يحتاج إعادة ربط",
    disconnected: "مفصول",
    syncing: "جارٍ المزامنة",
  },
  intents: {
    question: "سؤال",
    price: "سعر",
    purchase: "شراء",
    collab: "تعاون",
    complaint: "شكوى",
    praise: "إشادة",
    spam: "مزعج",
    hate: "إساءة",
    other: "أخرى",
  },
  sentiments: {
    positive: "إيجابي",
    neutral: "محايد",
    negative: "سلبي",
  },
  inboxStates: {
    open: "مفتوح",
    done: "منجز",
    snoozed: "مؤجّل",
  },
  roles: {
    owner: "مالك",
    admin: "مسؤول",
    editor: "محرّر",
    viewer: "مشاهد",
  },
  postTypes: {
    image: "صورة",
    video: "فيديو",
    carousel: "ألبوم",
    reel: "ريل",
    story: "ستوري",
    text: "نص",
  },
  postStatus: {
    draft: "مسودة",
    in_review: "قيد المراجعة",
    approved: "معتمد",
    scheduled: "مجدول",
    publishing: "جارٍ النشر",
    published: "منشور",
    partially_published: "منشور جزئياً",
    failed: "فشل",
    cancelled: "ملغى",
  },
  metrics: {
    reach: "الوصول",
    views: "المشاهدات",
    accounts_engaged: "الحسابات المتفاعلة",
    total_interactions: "التفاعلات",
    likes: "الإعجابات",
    comments: "التعليقات",
    shares: "المشاركات",
    saves: "الحفظ",
    saved: "الحفظ",
    followers: "المتابعون",
    follower_count: "المتابعون",
    profile_views: "زيارات الملف",
    engagement: "التفاعل",
    engagementRate: "معدل التفاعل",
  },
  time: {
    today: "اليوم",
    yesterday: "أمس",
    tomorrow: "غداً",
    thisWeek: "هذا الأسبوع",
    last7: "آخر 7 أيام",
    last28: "آخر 28 يوماً",
    last90: "آخر 90 يوماً",
    days_zero: "{{count}} يوم",
    days_one: "يوم واحد",
    days_two: "يومان",
    days_few: "{{count}} أيام",
    days_many: "{{count}} يومًا",
    days_other: "{{count}} يوم",
    vsPrevious: "مقارنة بالفترة السابقة",
    now: "الآن",
  },
  weekdays: {
    sun: "الأحد",
    mon: "الإثنين",
    tue: "الثلاثاء",
    wed: "الأربعاء",
    thu: "الخميس",
    fri: "الجمعة",
    sat: "السبت",
  },
  a11y: {
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    collapseNav: "طيّ الشريط الجانبي",
    expandNav: "توسيع الشريط الجانبي",
    skipToContent: "انتقل إلى المحتوى",
    loading: "جارٍ التحميل",
    selected: "محدد",
    notifications: "الإشعارات",
    userMenu: "قائمة الحساب",
    dismiss: "إغلاق",
  },
  confirm: {
    title: "هل أنت متأكد؟",
    deleteTitle: "حذف هذا العنصر؟",
    irreversible: "لا يمكن التراجع عن هذا الإجراء.",
  },
  ai: {
    label: "ذكاء",
    poweredBy: "بمساعدة الذكاء الاصطناعي",
    thinking: "يفكّر…",
    drafted: "صاغه الذكاء الاصطناعي",
    confidence: "الثقة",
  },
  sendError: {
    notSent: "لم يُرسل: {{reason}}",
    retry: "إعادة المحاولة",
    retrying: "جارٍ الإرسال مجددًا…",
    codes: {
      channel_reauth_required: "يجب إعادة ربط إنستغرام",
      messaging_window_closed: "نافذة الـ24 ساعة مغلقة: يجب أن يراسلك العميل أولًا",
      rate_limited: "فشل الإرسال",
      provider_error: "فشل الإرسال",
      unknown: "فشل الإرسال",
      validation: "رفض إنستغرام المحتوى (طويل جدًا، أو رابط أو مرفق غير صالح)",
      capability_not_supported: "لا تدعم هذه القناة هذا الإجراء",
      forbidden: "لم يسمح إنستغرام بهذا الإجراء لهذا الحساب",
      not_found: "لم يعد موجودًا على إنستغرام (حُذف أو غير متاح)",
      outbound_disabled: "الإرسال متوقف من قِبل مسؤول المنصة",
      conflict: "تم ذلك مسبقًا أو تغيّر في هذه الأثناء",
      limit_reached: "وصلت إلى حد خطتك لهذه الفترة",
      feature_not_in_plan: "خطتك لا تتضمن هذه الميزة",
      ai_unavailable: "خدمة الذكاء الاصطناعي غير متاحة الآن",
      budget_exceeded: "انتهت ميزانية الذكاء الاصطناعي لهذا الشهر",
      storage_error: "تعذّر حفظ النتيجة (خطأ في التخزين)",
      content_policy: "رفض مزوّد الذكاء الاصطناعي هذا الطلب (سياسة المحتوى)",
      timeout: "استغرق وقتًا طويلًا فأُوقف",
    },
  },
  level: { low: "منخفض", medium: "متوسط", high: "مرتفع", unknown: "غير مقيّم" },
  technical: { title: "تفاصيل تقنية", hint: "يراها فريق منصة ملفك فقط." },
};
